export default __webpack_public_path__ + "static/media/banner3.1c795603.jpg";